export enum ColorsEnum {
  BrandPrimaryDark15 = 'rgb(0, 100, 143)',
  BrandPrimaryBase = 'rgb(0, 152, 218)',
  BrandPrimaryLight20 = 'rgb(66, 198, 255)',
  BrandPrimaryLight40 = 'rgb(168, 229, 255)',
  BrandPrimaryLight55 = 'rgb(240, 250, 255)',
  BrandSecondaryBase = 'rgb(46, 43, 96)',
  BrandSecondaryLight30 = 'rgb(108, 104, 187)',
  BrandSecondaryLight50 = 'rgb(176, 174, 219)',
  BrandSecondaryLight55 = 'rgb(227, 227, 242)',
  BrandSecondaryLight65 = 'rgb(245, 244, 250)',
  NeutralDarkest = 'rgb(0, 0, 0)',
  NeutralDark60 = 'rgb(13, 27, 43)',
  NeutralDark50 = 'rgb(38, 55, 76)',
  NeutralDark40 = 'rgb(51, 74, 102)',
  NeutralDark35 = 'rgb(84, 105, 130)',
  NeutralDark15 = 'rgb(135, 152, 173)',
  NeutralBase = 'rgb(171, 189, 210)',
  NeutralLight10 = 'rgb(207, 222, 229)',
  NeutralLight20 = 'rgb(229, 239, 249)',
  NeutralLight22 = 'rgb(242, 244, 247)',
  NeutralLight25 = 'rgb(245, 248, 250)',
  NeutralLightest = 'rgb(255, 255, 255)',
  YellowDark25 = 'rgb(127, 102, 0)',
  YellowBase = 'rgb(255, 204, 0)',
  YellowLight20 = 'rgb(255, 224, 102)',
  YellowLight35 = 'rgb(255, 240, 178)',
  YellowLight45 = 'rgb(255, 250, 229)',
  OrangeDark15 = 'rgb(153, 82, 0)',
  OrangeBase = 'rgb(255, 136, 0)',
  OrangeLight20 = 'rgb(255, 184, 102)',
  OrangeLight30 = 'rgb(255, 207, 153)',
  OrangeLight45 = 'rgb(255, 243, 229)',
  BlueLightDark15 = 'rgb(4, 124, 124)',
  BlueLightBase = 'rgb(6, 198, 198)',
  BlueLightLight10 = 'rgb(25, 217, 217)',
  BlueLightLight40 = 'rgb(156, 252, 252)',
  BlueLightLight55 = 'rgb(230, 254, 254)',
  GreenDark15 = 'rgb(4, 124, 71)',
  GreenBase = 'rgb(6, 198, 114)',
  GreenLight20 = 'rgb(57, 249, 165)',
  GreenLight40 = 'rgb(156, 252, 210)',
  GreenLight55 = 'rgb(230, 254, 244)',
  RedDark20 = 'rgb(204, 0, 0)',
  RedBase = 'rgb(255, 51, 51)',
  RedLight10 = 'rgb(255, 102, 102)',
  RedLight20 = 'rgb(255, 153, 153)',
  RedLight35 = 'rgb(255, 229, 229)',
  BlueDark10 = 'rgb(0, 72, 178)',
  BlueDark20 = 'rgb(0,74,117)',
  BlueBase = 'rgb(0, 92, 229)',
  BlueLight20 = 'rgb(76, 148, 255)',
  BlueLight40 = 'rgb(178, 209, 255)',
  BlueLight55 = 'rgb(229, 240, 255)',
  PurpleDark25 = 'rgb(76, 0, 153)',
  PurpleBase = 'rgb(102, 0, 204)',
  PurpleLight20 = 'rgb(153, 51, 255)',
  PurpleLight40 = 'rgb(204, 153, 255)',
  PurpleLight55 = 'rgb(242, 229, 255)',
}
